/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { StyleSheet } from 'react-native-unistyles';
import { pd, getFontWeight } from '@airasia-phoenix/react-native/utils';
export const styles = StyleSheet.create((pd) => ({
  container: {
    width: '100%',
    paddingHorizontal: {
      xs: 4,
      md: 0,
    },
  },
  carouselWrapper: {
    position: 'relative',
    width: '100%',
    overflow: 'visible',
  },
  bannerWrapper: {
    position: 'relative',
    borderRadius: 24,
    overflow: 'hidden',
    backgroundColor: pd.sys.colour.bg_primary.toString(),
    height: {
      xs: 240,
      md: 304,
    },
  },
  bannerSlide: {
    height: '100%',
  },
  innerContent: {
    flex: 1,
    justifyContent: 'space-between',
    paddingBottom: pd.ref.space.spacing20.px,
    paddingTop: {
      xs: 32,
      md: pd.ref.space.spacing60.px,
    },
    paddingHorizontal: {
      xs: 24,
      md: pd.ref.space.spacing90.px,
    },
  },
  textWrapper: { maxWidth: '85%' },
  title: {
    marginTop: pd.ref.space.spacing60.px,
    fontSize: {
      xs: 24,
      md: 48,
    },
    lineHeight: {
      xs: 44,
      md: 62,
    },
  },
  subtitle: {
    marginTop: pd.ref.space.spacing10.px,
    fontSize: {
      xs: 14,
      md: 24,
    },
    lineHeight: {
      xs: 32,
    },
  },
  promoBadge: {
    marginTop: pd.ref.space.spacing10.px,
    backgroundColor: pd.sys.colour.interactive_link.toString(),
    paddingVertical: pd.ref.space.spacing10.px,
    paddingHorizontal: pd.ref.space.spacing10.px,
    borderRadius: 8,
    alignSelf: 'flex-start',
  },
  promoTextStyle: {
    color: pd.sys.colour.bg_primary.toString(),
    fontSize: 12,
    fontWeight: getFontWeight(800),
  },
  paginationOverlay: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: pd.ref.space.spacing40.px,
    alignItems: 'center',
    zIndex: 20,
  },
  pagination: { flexDirection: 'row', justifyContent: 'center', gap: 8 },
  dot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: pd.sys.colour.bg_primary.toString(),
  },
  activeDot: {
    width: 20,
    backgroundColor: pd.sys.colour.bg_primary.toString(),
  },
  chevron: {
    position: 'absolute',
    top: '50%',
    marginTop: -16,
    width: 32,
    height: 32,
    backgroundColor: pd.sys.colour.bg_primary.toString(),
    borderRadius: 22,
    borderWidth: 1,
    borderColor: pd.sys.colour.outline_low.toString(),
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10,
    display: 'none',
  },
  visible: {
    display: 'flex',
  },
  leftChevron: { left: -pd.ref.space.spacing40.px, overflow: 'hidden' },
  rightChevron: { right: -pd.ref.space.spacing40.px, overflow: 'hidden' },
  tncText: {
    color: pd.sys.colour.bg_primary.toString(),
    fontSize: 10,
    opacity: 0.7,
    marginTop: pd.ref.space.spacing10.px,
  },
}));
export default styles;
